import { DataSourceSetupComposite, enumATSModes } from "./DataSourceSetupComposite";

export const JobviteSetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  return (
    <DataSourceSetupComposite
      config={config}
      onChange={onChange}
      index={index}
      chartConfig={chartConfig}
      showInputControls
      showConfiguration={importType !== "import"}
      showLoadHeaders={true}
      importType={importType}
      ATSType={enumATSModes.pureATS}
    />
  );
};
